import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

const PreviewHome = () => {
  return (
    <div>
      <section className="relative h-screen flex items-center justify-center overflow-hidden">
        <div className="absolute inset-0">
          <img 
            src="https://images.unsplash.com/photo-1629909613654-28e377c37b09?q=85&w=2400"
            alt="Modern Medical Office"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-spire-purple/95 via-spire-purple/85 to-purple-900/70"></div>
        </div>
        
        <div className="relative max-w-5xl mx-auto px-6 lg:px-8 text-center z-10">
          <h1 className="text-6xl md:text-7xl font-bold text-white mb-6 animate-fade-in-up">
            Your Trusted Partner in<br />Healthcare Real Estate
          </h1>
          <p className="text-2xl text-white/90 mb-10 max-w-3xl mx-auto animate-fade-in-up" style={{animationDelay: '200ms'}}>
            Expert consulting for healthcare professionals across North America
          </p>
          <Link 
            to="/preview/contact"
            className="inline-flex items-center px-8 py-4 bg-white text-spire-purple rounded-xl font-semibold text-lg hover:bg-gray-100 transition-all duration-300 hover:scale-105 shadow-xl animate-fade-in-up"
            style={{animationDelay: '400ms'}}
          >
            Get Started
            <ArrowRight className="ml-2" size={20} />
          </Link>
        </div>
      </section>
    </div>
  );
};

export default PreviewHome;